module.exports = __webpack_public_path__ + "assets/icon-unlocked-green.e0d97b5d.svg";